import React, {Suspense, Fragment, useState, useEffect} from 'react'
import { useForm, Controller } from "react-hook-form";
import {Col, Row} from "react-bootstrap";
import cx from "classnames";
import {
    formatDate,
    getFieldWidget,
    getPickLists, getRootStyle, getUpdatedFieldValue,
    handleErrorResponse, populateFormDetails, prepareDefaultValueList, prepareFieldAccessDetails,
    showToast
} from "../../Common/Appcommon";
import requestApi from "../../services/requestApi.service";
import Common from "../../Common/Common";
import CommonHeaderContent from "../../Common/CommonHeaderContent";
import {faFloppyDisk} from "@fortawesome/free-regular-svg-icons";

const Form = props => {

    let formId = props.formid || (props.match !== undefined ? props.match.params.id : undefined);
    let formname = props.formname || (props.match !== undefined ? props.match.params.formname : "");
    let settingsForm= props.settingsForm || false;
    let title = props.title || "";
    const defaultFields = props.defaultFields || {};

    let dataRow = [];
    let isNew = false;
    if(formId === undefined){
        isNew = true;
    }
    let buttonClickRef = React.createRef();
    const [leadRow, setLeadRow] = useState(dataRow);
    const [showLoader, setShowLoader] = useState(false);
    const [rerender, setViewRerender] = useState(false);
    const [formDetail, setFormDetail] = useState([]);
    const [fieldChanges, setFieldChangeDetails] = useState({})
    const [tagInfo, setTagInfo] = useState([]);
    const { register, handleSubmit,control, formState: { errors } } = useForm();

    if(title === ""){
        title = isNew ? "New Lead" : "Update Lead";
    }

    useEffect(() => {
        (async () => {
            setShowLoader(true);
            let formdetail = await populateFormDetails(formname);
            setFormDetail(formdetail);
            if(formId !== undefined){
                await getSelectedDataRow(formId);
            } else {
                let defaultData = await prepareDefaultValueList(formdetail);
                setLeadRow(defaultData);
            }
            setShowLoader(false);
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);

    const getSelectedDataRow = async (id) => {
        let params = {
            "ENTITY": "FORMPROCESS",
            "OPERATION": "GETSELECTEDRECORD",
            "FORMNAME": formname,
            "FORMID": id,
            "ISAPIREQ" : true
        };

        let response = await requestApi.processServerRequest(params,'WebV2','get');
        if(response.issuccess) {
            dataRow = response.data;
            setLeadRow(dataRow);
        }
    }
    const onChange = (e, valueInfo, attributes) => {

        let dataRow = leadRow;
        let fieldName = attributes['fieldName'];
        dataRow = getUpdatedFieldValue(valueInfo,attributes,dataRow);
        if (attributes['fieldType'] === "MultiComboBox"){
            if(attributes !== undefined && attributes['custom_property'] !== undefined){
                setTagInfo(valueInfo);
            }
        }
        setLeadRow(dataRow);
        setViewRerender(!rerender);
        let fieldchangedetails = fieldChanges;
        fieldchangedetails[fieldName] = fieldName;
        setFieldChangeDetails(fieldchangedetails);
        //setViewRerender(false);
    }
    const onFormSubmit = async () =>{
        let formData = {};
        let fieldChangeDetails = fieldChanges;
        let formFieldDetails = {};
        let formInfo = formDetail[0];
        let moduleName = formInfo[0];
        let fieldDetails = formDetail[1];
        fieldDetails.map((field)=> {
            let fieldName = field[2];
            let fieldLabel = field[3];
            let fieldType = field[4];
            if(fieldType !== "reference_entityid" && fieldType !== "subtable"){
                let fieldValue = fieldType === "form_entityid" ? leadRow[fieldName] : leadRow[fieldLabel];
                formData[fieldName] = fieldValue === undefined ? "" : fieldValue;

                if(fieldName === props.formname+"_id" && !isNew){
                    formData[fieldName] = props.formid;
                }

                let defaultValue = field[19];
                let isFieldChanged = false;
                if(fieldChangeDetails[fieldName] !== undefined){
                    isFieldChanged = true;
                }
                let fType = fieldType;
                if(fieldType === "entity_group" || fieldType === "reference_group"){
                    fType = "reference_entityid";
                }
                let fieldInfo = [fType,defaultValue,isFieldChanged];
                let refFieldInfo = [];
                let refFieldKey = "";
                if(fieldType === "reference"){
                    let refDetail = field[35];
                    fieldInfo = ["reference_entityid",defaultValue,isFieldChanged];
                    //if(refDetail[1] !== "table_6"){
                        refFieldKey = fieldName.replace("_id","_name");
                        formData[refFieldKey] = leadRow[refFieldKey];
                        refFieldInfo = [fieldType,defaultValue,isFieldChanged,refDetail[1], refDetail[2], refDetail[3]];
                    //}
                }
                formFieldDetails[fieldName] = fieldInfo;
                if(refFieldKey !== ""){
                    formFieldDetails[refFieldKey] = refFieldInfo;
                }
            }

        });

        //update default values in form.
        formData = {
            ...formData,
            ...defaultFields
        };

        let auditInfo = {"displaystring" : ""};
        formData["SUBTABLE_INPUTFIELDS"] = [];
        formData["SUBTABLELINK_INPUTFIELDS"] = [];
        formData["LINEITEM_INPUTFIELDS"] = [];
        formData["BASETABLE_INPUTFIELDS"] = [];
        let params = {
            "ENTITY": "FORMPROCESS",
            "OPERATION": isNew ? "SAVE" : "EDIT",
            "MODULENAME" : moduleName,
            "FORMNAME" : formname,
            "concurrent_process_confirmed" : true,
            "FORMTYPE" : "",
            "auditinfo" : auditInfo,
            "FORM_INPUTFIELDS" : formData,
            "FORM_FIELDSDETAIL" : formFieldDetails,
        };
        if(tagInfo.length > 0){
            params["tagInfo"] = tagInfo;
        }
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess) {
            if(!settingsForm){
                let successMsg = "Lead created successfully.";
                if(!isNew){
                    successMsg = "Lead updated successfully.";
                }
                showToast(successMsg,"top-right","success",function () {
                    window.location.href = "#/leads";
                }, 1500);
            }else{
                if(props.onsave !== undefined){
                    props.onsave(formData);
                }
            }
        } else {
            handleErrorResponse(response.errormsg);
        }
    }

    const getDesiredField = (field, fieldType, fieldName, fieldLabel, defaultValue, fieldDetail, fieldAccess) => {
        return getFieldWidget(fieldDetail, onChange, errors, leadRow, field,fieldAccess);
    }

    const onLeadFormSave = async (e) => {
        await buttonClickRef.current.click();
    }
    if(formDetail.length > 0 && (isNew || Object.keys(leadRow).length > 0)) {
        let formInfo = formDetail[0];
        let fieldDetails = formDetail[1];
        let screenAccessDetails = formDetail[11];
        let fieldAccessDetails = prepareFieldAccessDetails(screenAccessDetails);
        let moduleName = formInfo[0];
        let style = formInfo[12];
        let skipFields = [
            `${formname}_id`,
            'Lead_ID',
            'wsapp_recent_activity',
            'wsapp_convo_status',
            'wsapp_unread_count',
            'wsapp_optin_status',
            'wsapp_recent_msg_id',
            'wsapp_enabled',
            'wsapp_blocked',
            'wsapp_opt',
            'wsapp_last_delivered',
            'wsapp_last_read',
            'wsapp_last_replied',
            'wsapp_last_sent_msg_id',
            'wsapp_last_sent_msg_id',
            'wsapp_completed_campaign'
        ];
        let fieldDetailsMapper = {};
        fieldDetails.map((field) => {
            let fieldName = field[2];
            let fieldorder = field[22];
            fieldDetailsMapper[fieldorder] = field;
        })
        let formStyle = getRootStyle(style,fieldDetailsMapper);
        let map = formStyle['map'];
        let glist = formStyle['grouplist'];
        let basiclist = formStyle['needforbasic'];
        let forderlist = formStyle['forderlist'];

        let addonButtons = [];

        if(props.addonButtons){
            addonButtons = props.addonButtons;
        }

        function getContent(){
            return (
                <Fragment>
                    <CommonHeaderContent addonButtons={addonButtons} buttonAction={onLeadFormSave} headerTitle={title} buttonIcon={faFloppyDisk} buttonTxt={"Save & Close"} mainContent={
                        <div className={cx('form-panel overflow-scroll',{
                            "mb-5" : settingsForm
                        })}>
                            <div className="container">
                                <Row className={'flex mt-3'}>
                                    <form name={formname + '_form'} className={''}
                                          onSubmit={handleSubmit(onFormSubmit)}>
                                        {
                                            glist.map((groupkey) => {
                                                if (groupkey !== "g_root" && map[groupkey] !== undefined) {
                                                    let garr = groupkey.split("g_");
                                                    let groupName = garr[1];
                                                    let layout = map[groupkey]['layout'];
                                                    let columnClass = layout === 1 ? "col-sm-12" : layout === 3 ? "col-sm-4" : "";
                                                    let customStyleClass = layout === 2 ? "cl2" : layout === 3 ? "cl3" : "";

                                                    return (
                                                        <div className="main-card card form-field-group mb-2">
                                                            <div className="card-body form-fields-body ">
                                                                <h5 className="card-title">{groupName}</h5>
                                                                {
                                                                    forderlist[groupkey].map((fieldKey) => {
                                                                        let foarr = fieldKey.split('f_');
                                                                        let fieldOrder = foarr.length > 1 ? foarr[1] : '';
                                                                        let fieldDetail = fieldDetailsMapper[fieldOrder];
                                                                        if(fieldDetail === undefined){
                                                                            return <></>
                                                                        }
                                                                        let fieldName = fieldDetail[2];
                                                                        let fieldType = fieldDetail !== undefined ? fieldDetail[4] : "";
                                                                        let islabeldisplay = fieldDetail !== undefined ? fieldDetail[29] : "";
                                                                        let isConfigHide = parseInt(fieldDetail[10]);
                                                                        let isViewHide = parseInt(fieldDetail[11]);
                                                                        let isMandatory = parseInt(fieldDetail[16]);
                                                                        let defaultValue = fieldDetail[19];
                                                                        let fieldLabel = fieldDetail[3];
                                                                        let fieldValue = leadRow[fieldLabel];
                                                                        if (!isConfigHide && (!isViewHide || (fieldType === "Image" && props.formname === "table_21") ) && fieldAccessDetails[fieldName] !== 2) {
                                                                            if (fieldType !== 'subtable' && fieldType !== 'reference_entityid' && fieldType !== "reference_group" && fieldType !== "form_history") {
                                                                                if (!skipFields.includes(fieldName)) {
                                                                                    return (
                                                                                        <div
                                                                                            className={`field-container ${columnClass} ${customStyleClass}`}>
                                                                                            <label
                                                                                                className={'group-header-lbl'}
                                                                                                htmlFor="triggerMsg">{fieldLabel} <span className={'text-danger'}>{isMandatory ? "*" : ""}</span></label>
                                                                                            <Controller
                                                                                                name={fieldName + "_fieldinput"}
                                                                                                control={control}
                                                                                                rules={{required: isMandatory && (fieldValue === undefined || fieldValue=== "" || fieldValue=== null) ? fieldLabel + " is required" : ""}}
                                                                                                render={({field}) => {
                                                                                                    return getDesiredField(field, fieldType, fieldName, fieldLabel, defaultValue, fieldDetail, fieldAccessDetails[fieldName]);
                                                                                                }}
                                                                                            />
                                                                                            {errors[fieldName + "_fieldinput"] &&
                                                                                            <em className={`error invalid-feedback`}>{errors[fieldName + "_fieldinput"].message}</em>}
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })
                                        }
                                        <div className={'mt-3 text-center hide'}>
                                            <button ref={buttonClickRef}
                                                    className="btn-wide mb-2 me-2 lyte-button lytePrimaryBtn"
                                                    size="lg"
                                                    color="primary">
                                                Save
                                            </button>
                                        </div>

                                    </form>
                                </Row>
                            </div>
                        </div>
                    } />
                </Fragment>
            );
        }

        if(settingsForm){
            return getContent();
        }else{
            return (
                <Common rerender={rerender} pageTitle={"Leads"} showLoader={showLoader}
                        mainContent={
                            getContent()
                        }/>
            )
        }
    }
}

export default Form;
